import { render } from "./ProductBrief.vue?vue&type=template&id=1964d9d0"
import script from "./ProductBrief.vue?vue&type=script&lang=js"
export * from "./ProductBrief.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__